// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { Box, Checkbox, FormControlLabel, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useTheme } from "@mui/system";
import stylesDef from "./styles";
import { useState } from "react";

interface AddOnItemProps {
  item: ISubtypeDeliverable,
  selectedAddons: { _id: string, is3D: boolean }[],
  handleAddonCheck: (event: any, id: string, is3D?: boolean) => void,
  available3D: boolean,
}

const AddOnItem = ({ item, handleAddonCheck, available3D }: AddOnItemProps) => {
  const theme = useTheme();
  const styles = stylesDef(theme);

  const [checked, setChecked] = useState<boolean>(false);
  const [type, setType] = useState<'2D' | '3D'>('2D');

  const handleTypeChange = (newType: '2D' | '3D') => {
    setType(newType);
  };

  const handleCheck = (event: any) => {
    const isChecked = event.target.checked;
    setChecked(isChecked);
    handleAddonCheck(event, item.id, isChecked && type === '3D');
  }

  return (
    <Box sx={styles.addOnItemContainer}>
      <FormControlLabel
        control={<Checkbox sx={styles.checked} />}
        label={item.name}
        onChange={(event) => handleCheck(event)}
        checked={checked}
      />
      {available3D &&
        (
          <ToggleButtonGroup
            value={type}
            exclusive
            onChange={(_event, value) => handleTypeChange(value)}
          >
            <ToggleButton
              value="2D"
              sx={type === '2D' ? styles.selected : styles.notSelected}
              disabled={type === '2D'}
            >
              2D
            </ToggleButton>
            <ToggleButton
              value="3D"
              sx={type === '3D' ? styles.selected : styles.notSelected}
              disabled={type === '3D'}
            >
              3D
            </ToggleButton>
          </ToggleButtonGroup>
        )
      }
    </Box>
  );
}

export default AddOnItem;
